/**
 * Mobile App pages — thin wrappers around the existing Portal pages so
 * EVERYTHING synchronizes automatically:
 * - Same backend endpoints
 * - Same components
 * - Same data
 *
 * The wrappers just hide the desktop chrome (which is already done because
 * MobileAppLayout doesn't render PortalLayout) and apply a few mobile spacing
 * tweaks via .dccf-app-main padding rules.
 */
import React, { lazy, Suspense } from 'react';

const Loader = () => (
  <div className="flex items-center justify-center py-16">
    <div className="w-7 h-7 border-2 border-slate-200 border-t-[#002249] rounded-full animate-spin" />
  </div>
);

// Lazy-load each portal page so the mobile bundle stays light
const PortalCommunity = lazy(() => import('../pages/portal/PortalCommunity'));
const PortalMessages = lazy(() => import('../pages/portal/PortalMessages'));
const PortalDashboard = lazy(() => import('../pages/portal/PortalDashboard'));
const PortalMemberDeals = lazy(() => import('../pages/portal/PortalMemberDeals'));
const PortalSocialProfile = lazy(() => import('../pages/portal/PortalSocialProfile'));

const wrap = (Component) => () => (
  <Suspense fallback={<Loader />}>
    <Component />
  </Suspense>
);

export const AppFeedPage = wrap(PortalCommunity);
export const AppMessagesPage = wrap(PortalMessages);
export const AppDealsPage = wrap(PortalMemberDeals);
export const AppNotificationsPage = wrap(PortalDashboard); // Dashboard already shows notifications/announcements
export const AppProfilePage = wrap(PortalSocialProfile);
